import { defineMessage } from 'services/localization';

export const messages = {
    placeholderText: defineMessage('leave_a_comment'),
    fileTooBigError: defineMessage('sorry_the_file_filename_maximum_size_of_maxsize'),
    fileExtensionNotSupportedError: defineMessage('sorry_the_submitted_file_type_is_not_supported'),
    failedToUploadFileGeneric: defineMessage('oops_the_file_upload_has_failed'),
    uploadErrorRestrictedFileType: defineMessage('sorry_the_file_type_of__due_to_security_reasons'),
    uploadErrorTooBig: defineMessage('sorry_the_file_filename_maximum_size_of_maxsize'),
    uploadErrorVirusFound: defineMessage('sorry_the_file_filename_hat_it_contains_a_virus'),
    uploadErrorGeneric: defineMessage('oops_something_went_wrong'),
    maxNumberOfAttachmentsExceeded: defineMessage('sorry_you_cannot_attach_that_files_to_a_comment'),
    dropHereText: defineMessage('drop_the_files_here'),
    uploadingText: defineMessage('uploading_1'),
};
